/**
 * The API sends `localized*` fields as a map keyed by language code, so
 * never render them directly (SQR-17423).
 */
export type LocalizedText = string | Record<string, string> | null;

/**
 * Returns undefined when the map has no entry for `language`, so callers
 * can fall back to the untranslated field.
 */
export const resolveLocalizedText = (
  value: LocalizedText | undefined,
  language: string,
): string | undefined => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;

  const baseLanguage = language.split('-')[0];
  const text = value[language] || value[baseLanguage];

  return text || undefined;
};
